import billDialogReducer from './billDialogReducer';

export default billDialogReducer;